export default {
  text: 'Avançar',
};
